export const getInitialValues = (drawerData, idx) => {
    const state = drawerData[idx]?.state || {};
    return {
      emailValue: state.emailValue || "ایمیل",
      mainEmailInput: state.mainEmailInput || "",
      exEmailValue: state.exEmailValue || "example@example.com",
    };
  };
  
  export const updateDrawerState = (drawerData, idx, nextState, readOnly) => {
    if (!drawerData[idx]) return;
    drawerData[idx].state = { ...drawerData[idx].state, ...nextState, readOnly };
  };
  
  export const validateEmail = (value) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);  